import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/airports'

export default {
  async getAll() {
    return await axios
      .get(endpoint + '/list')
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/airportService.js